/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {exportData} from '../api'

export const useMutationExportData = createReactQueryMutationHook('exportData', exportData)
